import React, {useEffect} from 'react';
import {Scanner} from '../veristamp';

const Scan = ({onScan}) => {

    useEffect(() => {
        let scanner = new Scanner();

        scanner.onSuccess = (code) => {
            onScan(code);
        };
        
        scanner.init("https://stamp.verigram.cloud", "test").then(() => {
            scanner.start();
        });

        return () => {
            scanner.dispose();
        };
    });

    return (
        <>
            <div id="veristamp"></div>
        </>
    );
}

export default Scan;
